<div class="container py-4">

  <!-- Header -->
  <div class="text-center mb-4">
    <h3 class="fw-bold">
      <i class="fa-solid fa-handshake me-2 text-warning"></i>
      Our Partners
    </h3>
    <p class="text-muted small">Meet amazing network partners listed with us</p>
  </div>

  <!-- Loading -->
  @if (loading) {
    <div class="text-center my-5">
      <div class="spinner-border text-warning"></div>
      <div class="small text-muted mt-2">Loading partners...</div>
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div class="alert alert-danger text-center">{{ error }}</div>
  }

  <!-- Table -->
  @if (!loading && partners.length) {
    <div class="table-responsive">
      <table class="table table-hover align-middle border">
        <thead class="table-light text-center">
          <tr>
            <th>Logo</th>
            <th>Company</th>
            <th>Website</th>
            <th>WhatsApp</th>
            <th>Expiry</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody class="text-center">
          @for (p of partners; track p) {
            <tr>
              <!-- Logo -->
              <td style="width:70px">
                @if (p.logo) {
                  <img
                    [src]="p.logo"
                    class="img-thumbnail border-0"
                    style="max-height:50px"
                    (error)="p.logo=''"
                  />
                } @else {
                  <i class="fa-solid fa-building text-secondary fa-lg"></i>
                }
              </td>

              <td class="text-start">{{ p.name }}</td>
              <td>{{ p.website }}</td>
              <td>{{ p.whatsapp }}</td>

              <td>
                @if (p.expired) {
                  <span class="badge bg-danger">
                    <i class="fa-solid fa-clock me-1"></i>
                    Expired
                  </span>
                } @else if (getRemainingTime(p)) {
                  <span
                    class="small fw-semibold"
                    [ngClass]="{
                      'text-success': getRemainingTime(p)!.days > 30,
                      'text-warning': getRemainingTime(p)!.days <= 30 && getRemainingTime(p)!.days > 0,
                      'text-danger': getRemainingTime(p)!.days === 0
                    }"
                  >
                    {{ getRemainingTime(p)!.days }}d
                    {{ getRemainingTime(p)!.hours }}h
                    {{ getRemainingTime(p)!.minutes }}m
                  </span>
                }
              </td>

              <!-- Action -->
              <td>
                <button
                  class="btn btn-sm py-1 px-1"
                  [class.btn-warning]="!p.expired"
                  [class.btn-success]="p.expired"
                  [disabled]="updatingId === p.id"
                  (click)="openConfirm(p)"
                >
                  {{ p.expired ? 'Activate' : 'Deactivate' }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Empty -->
  @if (!loading && !partners.length) {
    <div class="text-center text-muted my-5">
      No partners found
    </div>
  }

</div>

<app-confirm-dialog
  [show]="showConfirm"
  [title]="selectedPartner?.expired ? 'Activate Partner' : 'Deactivate Partner'"
  [message]="
    selectedPartner?.expired
      ? 'Are you sure you want to activate ' + selectedPartner?.name + '?'
      : 'Are you sure you want to deactivate ' + selectedPartner?.name + '?'
  "
  [confirmText]="selectedPartner?.expired ? 'Activate' : 'Deactivate'"
  [cancelText]="'Cancel'"
  [busy]="updatingId !== null"
  (confirm)="onConfirm()"
  (cancel)="onCancel()">
</app-confirm-dialog>
